import { render, staticRenderFns } from "./ChnlWhiteList.vue?vue&type=template&id=3dc4a6bd"
import script from "./ChnlWhiteList.vue?vue&type=script&lang=js"
export * from "./ChnlWhiteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports